/* tslint:disable */
/* eslint-disable */
/**
 * pricing API
 * Pricing service
 *
 * The version of the OpenAPI document: 38.848.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplicationContextClassLoaderParentDefinedPackagesInner
 */
export interface ApplicationContextClassLoaderParentDefinedPackagesInner {
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentDefinedPackagesInner
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentDefinedPackagesInner
     */
    specificationTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentDefinedPackagesInner
     */
    specificationVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentDefinedPackagesInner
     */
    specificationVendor?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentDefinedPackagesInner
     */
    implementationTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentDefinedPackagesInner
     */
    implementationVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentDefinedPackagesInner
     */
    implementationVendor?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoaderParentDefinedPackagesInner
     */
    sealed?: boolean;
    /**
     * 
     * @type {Array<object>}
     * @memberof ApplicationContextClassLoaderParentDefinedPackagesInner
     */
    annotations?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof ApplicationContextClassLoaderParentDefinedPackagesInner
     */
    declaredAnnotations?: Array<object>;
}

/**
 * Check if a given object implements the ApplicationContextClassLoaderParentDefinedPackagesInner interface.
 */
export function instanceOfApplicationContextClassLoaderParentDefinedPackagesInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApplicationContextClassLoaderParentDefinedPackagesInnerFromJSON(json: any): ApplicationContextClassLoaderParentDefinedPackagesInner {
    return ApplicationContextClassLoaderParentDefinedPackagesInnerFromJSONTyped(json, false);
}

export function ApplicationContextClassLoaderParentDefinedPackagesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationContextClassLoaderParentDefinedPackagesInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'specificationTitle': !exists(json, 'specificationTitle') ? undefined : json['specificationTitle'],
        'specificationVersion': !exists(json, 'specificationVersion') ? undefined : json['specificationVersion'],
        'specificationVendor': !exists(json, 'specificationVendor') ? undefined : json['specificationVendor'],
        'implementationTitle': !exists(json, 'implementationTitle') ? undefined : json['implementationTitle'],
        'implementationVersion': !exists(json, 'implementationVersion') ? undefined : json['implementationVersion'],
        'implementationVendor': !exists(json, 'implementationVendor') ? undefined : json['implementationVendor'],
        'sealed': !exists(json, 'sealed') ? undefined : json['sealed'],
        'annotations': !exists(json, 'annotations') ? undefined : json['annotations'],
        'declaredAnnotations': !exists(json, 'declaredAnnotations') ? undefined : json['declaredAnnotations'],
    };
}

export function ApplicationContextClassLoaderParentDefinedPackagesInnerToJSON(value?: ApplicationContextClassLoaderParentDefinedPackagesInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'specificationTitle': value.specificationTitle,
        'specificationVersion': value.specificationVersion,
        'specificationVendor': value.specificationVendor,
        'implementationTitle': value.implementationTitle,
        'implementationVersion': value.implementationVersion,
        'implementationVendor': value.implementationVendor,
        'sealed': value.sealed,
        'annotations': value.annotations,
        'declaredAnnotations': value.declaredAnnotations,
    };
}

